import { useEffect } from 'react';

const useSEO = ({ title, description }) => {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} — NestFlow` : 'NestFlow — Maximize Your Space Instantly';

    let metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute('content');
    if (description && metaDesc) {
      metaDesc.setAttribute('content', description);
    }

    return () => {
      document.title = prev;
      if (prevDesc && metaDesc) metaDesc.setAttribute('content', prevDesc);
    };
  }, [title, description]);
};

export default useSEO;
